const StiTableHeader = (props) => {
  const {
    stiColoumnWidth,
    sticolumnHeadingsQuotes,
    CommonStyleColumn,
    headingStyle,
  } = props;

  return (
    <div style={headingStyle}>
      <div style={{ width: stiColoumnWidth.first, ...CommonStyleColumn }}>
        {sticolumnHeadingsQuotes.first}
      </div>
      <div style={{ width: stiColoumnWidth.second, ...CommonStyleColumn }}>
        {sticolumnHeadingsQuotes.second}
      </div>
      <div style={{ width: stiColoumnWidth.third, ...CommonStyleColumn }}>
        {sticolumnHeadingsQuotes.third}
      </div>
      <div
        style={{
          width: stiColoumnWidth.fourth,
          ...CommonStyleColumn,
        }}
      >
        {sticolumnHeadingsQuotes.fourth}
      </div>
      <div
        style={{
          width: stiColoumnWidth.fifth,
          ...CommonStyleColumn,
          borderRight: 0,
        }}
      >
        {sticolumnHeadingsQuotes.fifth}
      </div>
    </div>
  );
};

export default StiTableHeader;
